/**
 * Created by hp on 2017/8/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LoadMore} from 'react-weui';

class WKShowMore extends Component {
    render() {
        const {loading, autoLoad = true, clickHandle} = this.props;

        if (autoLoad) {
            return (
                <div className="wk-show-more wk-border-line-after">
                    {loading ?
                        <LoadMore loading>加载中...</LoadMore>
                        :
                        <LoadMore showLine>没有更多了</LoadMore>
                    }
                </div>
            )
        } else {
            return (
                <div>
                    {loading &&
                        <div className="wk-show-more wk-border-line-after">
                            <p className="wsm-more" onClick={clickHandle}>查看更多</p>
                        </div>
                    }
                </div>
            )
        }
    }
}

export default connect((state) => ({
    wkShowMore: state.wk.wkShowMore
}))(WKShowMore);


// WEBPACK FOOTER //
// ./src/components/wk/WKShowMore.js